module.exports = __webpack_public_path__ + "static/media/tension_clamp_compression_type.4da2f9ce.webp";